module.exports = window.$bonelibs.React_16;